<template>
  <main class="section not-found-page">
    <div class="page-shell">
      <div class="not-found card panel">
        <h1>Page not found</h1>
        <p>The page you requested is not available. Return home or open the service request page.</p>
        <div class="actions">
          <router-link class="btn btn-primary" to="/">Home</router-link>
          <router-link class="btn btn-ghost" to="/services-request">Service Request</router-link>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>
.not-found-page {
  padding-top: clamp(10rem, 15vw, 12rem);
}

.not-found {
  display: grid;
  gap: 0.8rem;
}

.not-found h1 {
  font-size: var(--h1);
}

.not-found p {
  color: var(--text-muted);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}
</style>
